import React from "react";
import { GiEarthAmerica } from "react-icons/gi"
import { BsFillPersonFill, BsBarChartFill } from "react-icons/bs"
import { HiShieldCheck } from "react-icons/hi"

const aboutStats = [
    {
        id: 1,
        title: "4",
        subtitle: "offices globally",
        icon: <GiEarthAmerica/>
    },
    {
        id: 2,
        title: "50+",
        subtitle: "members in our team",
        icon: <BsFillPersonFill/>
    },
    {
        id: 3,
        title: "94%",
        subtitle: "customer satisfaction",
        icon: <HiShieldCheck/>
    },
    {
        id: 4,
        title: "27+",
        subtitle: "years of experience",
        icon: <BsBarChartFill/>
    },
]

export default aboutStats